import { Flex } from "@100mslive/hms-ai-ui";
import { isElement } from "lodash-es";
import React from "react";

import type { Step } from "../types";

export function Stepper({ step }: { step: Step }) {
  return (
    <Flex direction="column" className="max-w-2xl mx-auto gap-16">
      {step?.preview}
      <Flex direction="column" className="gap-3">
        <Flex className="gap-3 items-center">
          <div
            className=" p-2 rounded-lg bg-bg-brand-primary border border-bd-secondary"
            style={{
              boxShadow: `
      0px 1px 2px 0px #0A0D120D,
      inset 0px -2px 0px 0px #0A0D120D,
      inset 0px 0px 0px 1px #0A0D122E
    `,
            }}
          >
            {step.content.icon}
          </div>
          <p className="text-xl text-txt-primary font-medium">
            {step.content.title}
          </p>
        </Flex>
        {isElement(step.content.description) ? (
          step.content.description
        ) : (
          <p className="text-txt-tertiary text-sm">
            {step.content.description}
          </p>
        )}
        <Flex className="w-full">{step.input}</Flex>
      </Flex>
    </Flex>
  );
}
